'use strict';

module.exports = {
    update: function($metadata) {
        var model = this;
        Odigeo._.each(this.modelProps, function(prop) {
            return model.set(prop, $metadata.data(prop), {silent: true});
        });
    },

    filterRequest: function(requestType) {
        Odigeo.trigger(this.widget.widgetType + ':request', requestType, this.widget.name);
        Odigeo.trigger(this.widget.widgetType + ':setLastFilterUsed', this.widget.name, this.get('idx'));
    },

    getTagInfo: function() {
        return {};
    },

    modelProps: [],

    initModel: Odigeo._.noop,

    bindEvents: Odigeo._.noop,

    isFilterApplied: Odigeo._.noop,
};
